import type * as React from 'react'
import { useEffect } from 'react'

import { useController, useFormContext } from '@circlefin/form'
import { createFormInput } from '@circlefin/form/Form.Input'

import { getInputLabel } from '../../../getInputLabel/getInputLabel'

import type { FormInputFieldProps } from '../../../types'
import type { Field } from '@shared/openapi/types'

const Input = createFormInput()

export type StringEnumSingleProps = FormInputFieldProps<Field.StringField>

/**
 * Displays a single, read-only enum value for a string field.
 */
export const StringEnumSingle: React.FC<StringEnumSingleProps> = ({
  name,
  schema,
  prefix,
}) => {
  const fieldName = prefix ? `${prefix}.${name}` : name
  const label = getInputLabel({ schema, name, disabled: true })
  const { field } = useController({
    name: fieldName,
  })
  const { setValue, trigger } = useFormContext()

  // Set the default value and trigger validation on component mount since a user is not able to enter it themselves
  useEffect(() => {
    setValue(fieldName, schema.enum?.[0])
    void trigger(fieldName)
  }, [setValue, fieldName, schema.enum, trigger])

  return (
    <Input
      data-testid="string-enum-single"
      label={label}
      name={field.name}
      onBlur={field.onBlur}
      onChange={field.onChange}
      placeholder={schema.example}
      value={field.value as string}
      disabled
    />
  )
}
